import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function PageToggle({ options, active }) {
  const navigate = useNavigate();
  return (
    <div className="inline-flex bg-bg-surface rounded-r-lg p-[4px] gap-[4px]">
      {options.map((opt) => {
        const isActive = opt.value === active;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => {
              if (!isActive) navigate(opt.route);
            }}
            className={
              isActive
                ? 'px-sp-5 py-sp-2 text-sm font-bold rounded-r-md bg-bg-card text-text-primary shadow-sm'
                : 'px-sp-5 py-sp-2 text-sm font-bold rounded-r-md bg-transparent text-text-muted hover:text-text-secondary transition-colors'
            }
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
